import { createApp } from 'vue';

// Create a simple event bus
const app = createApp({});
export const eventBus = app.config.globalProperties.$eventBus = {
  emit(event, ...args) {
    document.dispatchEvent(new CustomEvent(event, { detail: args }));
  },
  on(event, callback) {
    const listener = (e) => callback(...(e.detail || []));
    document.addEventListener(event, listener);
    return () => document.removeEventListener(event, listener);
  }
}; 